import Backdrop from "components/Nav/Backdrop/Backdrop";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import RightNav from "./RightNav";

interface Props {
  open: boolean;
  pathname: string;
}

const StyledBurger = styled.div<Props>`
  width: 2rem;
  height: 2rem;
  position: ${({ open }) => (open ? "fixed" : "absolute")};
  top: 15px;
  right: 20px;
  z-index: 150;
  display: none;
  @media (max-width: 1050px) {
    display: flex;
    justify-content: space-around;
    flex-flow: column nowrap;
  }
  div {
    width: 2rem;
    height: 0.25rem;
    background-color: ${({ open }) => (open ? "#ccc" : props => (props.pathname === "/" ? "#ccc" : "#333"))};
    border-radius: 10px;
    transform-origin: 1px;
    transition: all 0.3s linear;
    &:nth-child(1) {
      transform: ${({ open }) => (open ? "rotate(45deg)" : "rotate(0)")};
    }
    &:nth-child(2) {
      transform: ${({ open }) => (open ? "translateX(100%)" : "translateX(0)")};
      opacity: ${({ open }) => (open ? 0 : 1)};
    }
    &:nth-child(3) {
      transform: ${({ open }) => (open ? "rotate(-45deg)" : "rotate(0)")};
    }
  }
`;

const Burger = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const handleClick = () => {
    setOpen(!open);
  };
  return (
    <>
      <StyledBurger open={open} onClick={() => setOpen(!open)} pathname={pathname}>
        <div />
        <div />
        <div />
      </StyledBurger>
      <Backdrop open={open} handleClick={handleClick} />
      <RightNav open={open} setOpen={setOpen} />
    </>
  );
};

export default Burger;
